import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";
import { useSubscription } from "@/provider/SubscriptionProvider";
import { useUpdateUiFlags } from "@/hooks/settings/useUpdateUiFlags";

interface AnnounceModalProps {
  onLearnMore: () => void;
  suppressed?: boolean;
}

export function AnnounceModal({
  onLearnMore,
  suppressed = false,
}: AnnounceModalProps) {
  const { status, seenReferralModal } = useSubscription();
  const { mutate: updateUiFlags } = useUpdateUiFlags();
  const [dismissed, setDismissed] = useState(false);

  const dismiss = () => {
    setDismissed(true);
    updateUiFlags({ seenReferralModal: true });
  };

  const handleLearnMore = () => {
    dismiss();
    onLearnMore();
  };

  const isOpen =
    status === "active" && !seenReferralModal && !dismissed && !suppressed;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && dismiss()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader className="text-center space-y-3">
          <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
            <Gift className="h-7 w-7 text-primary" />
          </div>
          <DialogTitle className="text-xl">Refer & Earn Free Months</DialogTitle>
          <DialogDescription className="text-sm">
            Know another gym owner? Refer them to FirstRep and earn a credit equal to their plan's monthly value off your next invoice.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-1">
          <Button onClick={handleLearnMore} className="w-full">
            Learn How It Works
          </Button>
          <Button
            variant="ghost"
            onClick={dismiss}
            className="w-full text-muted-foreground"
          >
            Maybe Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
